// src/services/order.service.js
import axios from "axios";
import { auth } from "../config/firebase";

const API_URL =
  process.env.REACT_APP_API_URL ||
  "http://localhost:5172/api" ||
  "https://ecommerce-backend-zynvert-253394384318.asia-south2.run.app/api";

const getAuthHeader = async () => {
  const user = auth.currentUser;
  if (!user) return {};
  const token = await user.getIdToken();
  return { Authorization: `Bearer ${token}` };
};

const orderService = {
  getMyOrders: async () => {
    const headers = await getAuthHeader();
    const res = await axios.get(`${API_URL}/orders`, { headers });
    return res.data;
  },

  getOrderById: async (orderId) => {
    const headers = await getAuthHeader();
    const res = await axios.get(`${API_URL}/orders/${orderId}`, { headers });
    return res.data;
  },

  cancelOrder: async (orderId, reason = "") => {
    const headers = await getAuthHeader();
    const res = await axios.put(
      `${API_URL}/orders/${orderId}/cancel`,
      { reason },
      { headers },
    );
    return res.data;
  },

  // ✅ NEW: Mark order as payment failed
  markPaymentFailed: async (orderId) => {
    const headers = await getAuthHeader();
    const res = await axios.put(
      `${API_URL}/orders/${orderId}/fail`,
      {}, // empty body
      { headers },
    );
    return res.data;
  },
  // Inside orderService
  retryPaymentSession: async (orderId) => {
    const headers = await getAuthHeader();
    const res = await axios.post(
      `${API_URL}/payments/${orderId}/retry`,
      {},
      { headers },
    );
    return res.data;
  },

  // (You also need a confirm route if you don't have a generic one)
  confirmRetryPayment: async (data) => {
    const headers = await getAuthHeader();
    const res = await axios.post(`${API_URL}/payments/confirm`, data, {
      headers,
    });
    return res.data;
  },
};

export default orderService;
